import { z } from "zod";

import { isDateWithinTextingHours } from "@stw/yup-validators";

import { useClock } from "./useClock";

export { isDateWithinTextingHours };

export function useTextingHours(textingHours: {
  start: string;
  end: string;
  timezone: string;
}): { isInTextingHours: boolean } {
  const now = useClock();
  return {
    isInTextingHours: isDateWithinTextingHours(now.toJSDate(), textingHours),
  };
}

export function createScheduleForSchema(textingHours: {
  start: string;
  end: string;
  timezone: string;
}): z.ZodType<Date | null | undefined> {
  return z.coerce
    .date()
    .nullish()
    .superRefine((schedule, ctx) => {
      const addIssue = (message: string) =>
        ctx.addIssue({ code: z.ZodIssueCode.custom, message });

      const outsideHours = !isDateWithinTextingHours(new Date(), textingHours);
      if (!schedule && outsideHours) {
        addIssue("Required when outside texting hours");
      }

      if (!schedule) {
        return;
      }

      if (schedule <= new Date()) {
        addIssue("Must be in the future");
      }

      if (!isDateWithinTextingHours(schedule, textingHours)) {
        addIssue("Must be within texting hours");
      }
    });
}
